import { Injectable } from '@angular/core';
import { routes } from '../routes/routes';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { apiResultFormat } from '../models/models';

/**
 * Forma mínima del `sideBar` para `sideBarSinPermisosRepetidos()`: solo lo que
 * ese método lee. No se usan `SubMenu`/`MenuItem` de `models.ts` porque ahí la
 * propiedad se llama `permission` y los datos reales usan `permision`.
 */
type EntradaMenu = {
  permision?: string;
  subMenus?: EntradaMenu[];
  [clave: string]: unknown;
};

type SeccionSideBar = {
  menu?: EntradaMenu[];
  [clave: string]: unknown;
};


@Injectable({
  providedIn: 'root',
})
export class DataService {
  constructor(private http: HttpClient) { }

  public getDoctorsList(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/doctors-list.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getPatientsList(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/doctors-list.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getStaffList(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/staff-list.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getAppointmentList(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/appointment-list.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getStaffHoliday(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/staff-holiday.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getSchedule(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/schedule.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getInvoices(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/invoices.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getPayments(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/payments.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getExpenses(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/expenses.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getTaxes(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/taxes.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getProvidentFund(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/provident-fund.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getDepartmentList(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/department-list.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getSalary(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/salary.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getAssetsList(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/assets-list.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getExpenseReports(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/expense-reports.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getInvoiceReports(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/invoice-reports.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getAllInvoice(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/all-invoice.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getPatientDashboard(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/patient-dashboard.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getInvoicesPaid(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/invoices-paid.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getInvoicesOverdue(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/invoices-overdue.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getInvoicesDraft(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/invoices-draft.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getInvoicesCancelled(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/invoices-cancelled.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getInvoicesRecurring(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/invoices-recurring.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getStaffLeave(): Observable<apiResultFormat> {
    return this.http.get<apiResultFormat>('assets/json/staff-leave.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getEvents() {
    return this.http.get<apiResultFormat>('assets/json/scheduleevents.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public getDataTables() {
    return this.http.get<apiResultFormat>('assets/json/data-tables.json').pipe(
      map((res: apiResultFormat) => {
        return res;
      })
    );
  }
  public sideBar = [
    {
      tittle: 'Principal',
      showAsTab: false,
      separateRoute: false,
      menu: [

        {
          menuValue: 'Usuarios',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'usuarios',
          img: 'assets/img/icons/menu-icon-08.svg',
          subMenus: [
            {
              menuValue: 'Director general',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'director_general',
              show_nav: false,
            },
            {
              menuValue: 'Listado usuario',
              route: routes.usuarioList,
              base: routes.usuarioList,
              permision: 'listado_usuario',
              show_nav: true,
            },
            {
              menuValue: 'Registro usuario',
              route: routes.usuarioRegister,
              base: routes.usuarioRegister,
              permision: 'registrar_usuario',
              show_nav: true,
            },
            {
              menuValue: 'Editar usuario',
              route: '',
              base: '',
              permision: 'editar_usuario',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar usuario',
              route: '',
              base: '',
              permision: 'eliminar_usuario',
              show_nav: false,
            },
            {
              menuValue: 'Perfil usuario',
              route: '',
              base: '',
              permision: 'perfil_usuario',
              show_nav: false,
            },
            {
              menuValue: 'Reenviar correo verificación',
              route: '',
              base: '',
              permision: 'reenviar_correo_verificacion',
              show_nav: false,
            },
            {
              menuValue: 'ver Directivos',
              route: '',
              base: '',
              permision: 'perfil_directivo',
              show_nav: false,
            },
            {
              menuValue: 'Encuesta de renovación RH',
              route: routes.renovacionEncuesta,
              base: routes.renovacionEncuesta,
              permision: 'renovacion_rh',
              show_nav: false,
            },
            {
              menuValue: 'Encuesta de renovación por Área',
              route: routes.renovacionEncuesta,
              base: routes.renovacionEncuesta,
              permision: 'renovacion_area_corresp',
              show_nav: false,
            },
            {
              menuValue: 'Encuesta de renovación Fiscal/Contabilidad',
              route: routes.renovacionEncuesta,
              base: routes.renovacionEncuesta,
              permision: 'renovacion_fiscal_contab',
              show_nav: false,
            },
            {
              menuValue: 'Listado bajas',
              route: routes.bajaList,
              base: routes.bajaList,
              permision: 'listado_bajas',

              show_nav: true,
            },
            {
              menuValue: 'Registrar bajas',
              route: routes.bajaList,
              base: 'usuarios',
              permision: 'registrar_bajas',

              show_nav: false,
            },
            {
              menuValue: 'Editar bajas',
              route: routes.bajaList,
              base: routes.bajaList,
              permision: 'editar_bajas',

              show_nav: false,
            },
            {
              menuValue: 'Procesar bajas',
              route: routes.bajaList,
              base: routes.bajaList,
              permision: 'procesar_bajas',

              show_nav: false,
            },
            {
              menuValue: 'Concluir bajas',
              route: routes.bajaList,
              base: 'usuarios',
              permision: 'concluir_bajas',

              show_nav: false,
            },
            {
              menuValue: 'Firmar baja colaborador',
              route: routes.bajaList,
              base: 'usuarios',
              permision: 'firmar_baja_colaborador',

              show_nav: false,
            },
            {
              menuValue: 'Firmar baja jefe',
              route: routes.bajaList,
              base: 'usuarios',
              permision: 'firmar_baja_jefe',

              show_nav: false,
            },
            {
              menuValue: 'Firmar baja finanzas',
              route: routes.bajaList,
              base: 'usuarios',
              permision: 'firmar_baja_finanzas',

              show_nav: false,
            },
            {
              menuValue: 'Firmar baja RH',
              route: routes.bajaList,
              base: 'usuarios',
              permision: 'firmar_baja_rh',
            },
            {
              menuValue: 'Firmar baja contraloría',
              route: routes.bajaList,
              base: 'usuarios',
              permision: 'firmar_baja_contraloria',
              show_nav: false,
            },
          ],
        },
        {
          menuValue: 'Empresas',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'empresas',
          img: 'assets/img/icons/menu-icon-06.svg',
          subMenus: [
            {
              menuValue: 'Listado empresas',
              route: routes.empresaList,
              base: routes.empresaList,
              permision: 'listado_empresa',
              show_nav: true,
            },
            {
              menuValue: 'Registro empresas',
              route: routes.empresaRegister,
              base: routes.empresaRegister,
              permision: 'registrar_empresa',
              show_nav: true,
            },
            {
              menuValue: 'Editar empresa',
              route: '',
              base: '',
              permision: 'editar_empresa',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar empresa',
              route: '',
              base: '',
              permision: 'eliminar_empresa',
              show_nav: false,
            },
            {
              menuValue: 'Perfil empresa',
              route: '',
              base: '',
              permision: 'perfil_empresa',
              show_nav: false,
            },
            {
              menuValue: 'Editar radio checador',
              route: '',
              base: '',
              permision: 'editar_radio_checador',
              show_nav: false,
            },
            {
              menuValue: 'Notificar admin de suscripción',
              route: '',
              base: '',
              permision: 'notificar_admin',
              show_nav: false,
            },
          ],
        },
        {
          menuValue: 'Roles y Permisos',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'gallery',
          base2: 'profile',
          icon: 'fa-columns',
          faIcon: true,
          subMenus: [
            {
              menuValue: 'Listado roles',
              route: routes.listadoRole,
              base: routes.listadoRole,
              permision: 'list_rol',
              show_nav: true,
            },
            {
              menuValue: 'Registro rol',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'register_rol',
              show_nav: true,
            },
            {
              menuValue: 'Editar rol',
              route: '',
              base: '',
              permision: 'edit_rol',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar rol',
              route: '',
              base: '',
              permision: 'delete_rol',
              show_nav: false,
            },
            {
              menuValue: 'Accesos por empleado',
              route: routes.accesosCruzadosPorEmpleado,
              base: routes.accesosCruzadosPorEmpleado,
              permision: 'gestionar_accesos_cruzados',
              show_nav: true,
            },
            {
              menuValue: 'Listado accesos cruzados',
              route: routes.accesosCruzadosListado,
              base: routes.accesosCruzadosListado,
              permision: 'gestionar_accesos_cruzados',
              show_nav: true,
            },
            {
              menuValue: 'Registro acceso cruzado',
              route: routes.accesosCruzadosRegistro,
              base: routes.accesosCruzadosRegistro,
              permision: 'gestionar_accesos_cruzados',
              show_nav: false,
            },
          ],
        },
        // {
        //   menuValue: 'Doctors',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'doctor',
        //   img: 'assets/img/icons/menu-icon-02.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Doctor List',
        //       route: routes.doctorsList,
        //       base: routes.doctorsList,
        //       permision: 'list_doctor',
        //       show_nav: true,
        //     },
        //     {
        //       menuValue: 'Add Doctor',
        //       route: routes.addDoctor,
        //       base: routes.addDoctor,
        //       permision: 'register_doctor',
        //       show_nav: true,
        //     },
        //     {
        //       menuValue: 'Edit Doctor',
        //       route: routes.editDoctor,
        //       base: routes.editDoctor,
        //       permision: 'edit_doctor',
        //       show_nav: false,

        //     },
        //     {
        //       menuValue: 'Doctor Profile',
        //       route: routes.doctorProfile,
        //       base: routes.doctorProfile,
        //       permision: 'profile_doctor',
        //       show_nav: true,
        //     },
        //   ],
        // },
        // {
        //   menuValue: 'Patients',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'patient',
        //   img: 'assets/img/icons/menu-icon-03.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Patients List',
        //       route: routes.patientsList,
        //       base: routes.patientsList,
        //       permision: 'list_patient',
        //       show_nav: true,
        //     },
        //     {
        //       menuValue: 'Add Patients',
        //       route: routes.addPatient,
        //       base: routes.addPatient,
        //       permision: 'register_patient',
        //       show_nav: true,
        //     },
        //     {
        //       menuValue: 'Edit Patients',
        //       route: routes.editPatient,
        //       base: routes.editPatient,
        //       permision: 'edit_patient',
        //       show_nav: false,
        //     },
        //     {
        //       menuValue: 'Patients Profile',
        //       route: routes.patientProfile,
        //       base: routes.patientProfile,
        //       permision: 'profile_patient',
        //       show_nav: true,
        //     },
        //   ],
        // },
        // {
        //   menuValue: 'Staff',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'staff',
        //   img: 'assets/img/icons/menu-icon-08.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Staff List',
        //       route: routes.staffList,
        //       base: routes.staffList,
        //     },
        //     {
        //       menuValue: 'Add Staff',
        //       route: routes.addStaff,
        //       base: routes.addStaff,
        //     },
        //     {
        //       menuValue: 'Staff Profile',
        //       route: routes.staffProfile,
        //       base: routes.staffProfile,
        //     },
        //     {
        //       menuValue: 'Leaves',
        //       route: routes.staffLeave,
        //       base: routes.staffLeave,
        //     },
        //     {
        //       menuValue: 'Holidays',
        //       route: routes.staffHoliday,
        //       base: routes.staffHoliday,
        //     },
        //     {
        //       menuValue: 'Attendance',
        //       route: routes.staffAttendance,
        //       base: routes.staffAttendance,
        //     },
        //   ],
        // },
        // {
        //   menuValue: 'Appointments',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'appointments',
        //   img: 'assets/img/icons/menu-icon-04.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Appointment List',
        //       route: routes.appointmentList,
        //       base: routes.appointmentList,
        //     },
        //     {
        //       menuValue: 'Book Appointment',
        //       route: routes.addAppointment,
        //       base: routes.addAppointment,
        //     },
        //     {
        //       menuValue: 'Edit Appointment',
        //       route: routes.editAppointment,
        //       base: routes.editAppointment,
        //     },
        //   ],
        // },
        // {
        //   menuValue: 'Doctor Schedule',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'doctor-schedule',
        //   img: 'assets/img/icons/menu-icon-05.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Schedule List',
        //       route: routes.schedule,
        //       base: routes.schedule,
        //     },
        //     {
        //       menuValue: 'Book Appointment',
        //       route: routes.addSchedule,
        //       base: routes.addSchedule,
        //     },
        //     {
        //       menuValue: 'Edit Appointment',
        //       route: routes.editSchedule,
        //       base: routes.editSchedule,
        //     },
        //   ],
        // },
        // {
        //   menuValue: 'Departments',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'departments',
        //   img: 'assets/img/icons/menu-icon-06.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Department List',
        //       route: routes.departmentList,
        //       base: routes.departmentList,
        //     },
        //     {
        //       menuValue: 'Add Department',
        //       route: routes.addDepartment,
        //       base: routes.addDepartment,
        //     },
        //     {
        //       menuValue: 'Edit Department',
        //       route: routes.editDepartment,
        //       base: routes.editDepartment,
        //     },
        //   ],
        // },
        // acounts
        // {
        //   menuValue: 'Accounts',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'accounts',
        //   img: 'assets/img/icons/menu-icon-07.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Invoices',
        //       route: routes.invoices,
        //       base: routes.invoices,
        //     },
        //     {
        //       menuValue: 'Payments',
        //       route: routes.payments,
        //       base: routes.payments,
        //     },
        //     {
        //       menuValue: 'Expenses',
        //       route: routes.expenses,
        //       base: routes.expenses,
        //     },
        //     {
        //       menuValue: 'Taxes',
        //       route: routes.taxes,
        //       base: routes.taxes,
        //     },
        //     {
        //       menuValue: 'Provident Fund',
        //       route: routes.providentFund,
        //       base: routes.providentFund,
        //     },
        //   ],
        // },
        // playroll
        // {
        //   menuValue: 'Payroll',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'payroll',
        //   img: 'assets/img/icons/menu-icon-09.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Employee Salary',
        //       route: routes.salary,
        //       base: routes.salary,
        //     },
        //     {
        //       menuValue: 'Payslip',
        //       route: routes.salaryView,
        //       base: routes.salaryView,
        //     },
        //   ],
        // },
        // chats
        // {
        //   menuValue: 'Chat',
        //   route: routes.chat,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: 'chat',
        //   img: 'assets/img/icons/menu-icon-10.svg',
        //   subMenus: [],
        // },
        // llamadas
        // {
        //   menuValue: 'Call',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'calls',
        //   img: 'assets/img/icons/menu-icon-11.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Voice Call',
        //       route: routes.voiceCall,
        //       base: routes.voiceCall,
        //     },
        //     {
        //       menuValue: 'Video Call',
        //       route: routes.videoCall,
        //       base: routes.videoCall,
        //     },
        //     {
        //       menuValue: 'Incoming Call',
        //       route: routes.incomingCall,
        //       base: routes.incomingCall,
        //     },
        //   ],
        // },
        // correo electronico
        // {
        //   menuValue: 'Email',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'email',
        //   img: 'assets/img/icons/menu-icon-12.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Compose Mail',
        //       route: routes.compose,
        //       base: routes.compose,
        //     },
        //     {
        //       menuValue: 'Inbox',
        //       route: routes.inbox,
        //       base: routes.inbox,
        //     },
        //     {
        //       menuValue: 'Mail View',
        //       route: routes.mailView,
        //       base: routes.mailView,
        //     },
        //   ],
        // },
        // blog
        // {
        //   menuValue: 'Blog',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'blogs',
        //   img: 'assets/img/icons/menu-icon-13.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Blog',
        //       route: routes.blog,
        //       base: routes.blog,
        //     },
        //     {
        //       menuValue: 'Blog View',
        //       route: routes.blogDetails,
        //       base: routes.blogDetails,
        //     },
        //     {
        //       menuValue: 'Add Blog',
        //       route: routes.addBlog,
        //       base: routes.addBlog,
        //     },
        //     {
        //       menuValue: 'Edit Blog',
        //       route: routes.editBlog,
        //       base: routes.editBlog,
        //     },
        //   ],
        // },
        // assets
        // {
        //   menuValue: 'Assets',
        //   route: routes.assetsList,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   icon: 'fa-cube',
        //   faIcon: true,
        //   base: 'assets',
        //   subMenus: [],
        // },
        // {
        //   menuValue: 'activities',
        //   route: routes.activities,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   img: 'assets/img/icons/menu-icon-14.svg',
        //   base: 'activities',
        //   permision: 'activitie',
        //   show_nav: true,
        //   subMenus: [],
        // },
        // {
        //   menuValue: 'Reportes',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'reports',
        //   img: 'assets/img/icons/menu-icon-02.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Expense Report',
        //       route: routes.expenseReports,
        //       base: routes.expenseReports,
        //       permision: 'expense_report',
        //       show_nav: true,
        //     },
        //     {
        //       menuValue: 'Invoice Report',
        //       route: routes.invoiceReports,
        //       base: routes.invoiceReports,
        //       permision: 'invoice_report',
        //       show_nav: true,
        //     },
        //   ],
        // },
        {
          menuValue: 'Ajustes',
          route: routes.settings,
          hasSubRoute: false,
          showSubRoute: false,
          img: 'assets/img/icons/menu-icon-16.svg',
          base: 'settings',
          permision: 'settings',
          show_nav: true,
          subMenus: [],
        },

        // {
        //   menuValue: 'Calendario',
        //   route: routes.settings,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   icon: 'fa-calendar',
        //   faIcon: true,
        //   base: 'calendario',
        //   permision: 'calendar',
        //   show_nav: true,
        //   subMenus: [],
        // },
        // {
        //   menuValue: 'Invoice',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'invoice',
        //   img: 'assets/img/icons/menu-icon-15.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Invoices List',
        //       route: routes.allInvoice,
        //       base: routes.allInvoice,
        //     },
        //     {
        //       menuValue: 'Invoice Grid',
        //       route: routes.invoicesGrid,
        //       base: routes.invoicesGrid,
        //     },
        //     {
        //       menuValue: 'Add Invoices',
        //       route: routes.addInvoice,
        //       base: routes.addInvoice,
        //     },
        //     {
        //       menuValue: 'Edit Invoices',
        //       route: routes.editInvoices,
        //       base: routes.editInvoices,
        //     },
        //     {
        //       menuValue: 'Invoices Details',
        //       route: routes.viewInvoice,
        //       base: routes.viewInvoice,
        //     },
        //     {
        //       menuValue: 'Invoices Settings',
        //       route: routes.invoicesSettings,
        //       base: routes.invoicesSettings,
        //     },
        //   ],
        // },
      ],
    },
    //Recursos humanos
    {
      tittle: 'Recursos humanos',
      showAsTab: false,
      separateRoute: false,
      menu: [
        {
          menuValue: 'Reclutamiento',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'reports',
          img: 'assets/img/icons/menu-icon-02.svg',
          subMenus: [
            {
              menuValue: 'Listado Reclutamiento',
              route: routes.reclutamientoList,
              base: routes.reclutamientoList,
              permision: 'listado_reclutamiento',
              show_nav: true,
            },
            {
              menuValue: 'Registro vacante',
              route: routes.reclutamientoRegister,
              base: routes.reclutamientoRegister,
              permision: 'registrar_vacante',
              show_nav: true,
            },
            {
              menuValue: 'Filtrado de CV',
              route: routes.filtradoCv,
              base: routes.filtradoCv,
              permision: 'registrar_vacante',
              show_nav: true,
            },
            {
              menuValue: 'Editar vacante',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_vacante',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar vacante',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_vacante',
              show_nav: false,
            },
            {
              menuValue: 'Procesar vacante',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'procesar_vacante',
              show_nav: false,
            },
            {
              menuValue: 'Directivo vacante',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'directivo_vacante',
              show_nav: false,
            },
            {
              menuValue: 'Contralor vacante',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'contralor_vacante',
              show_nav: false,
            },
          ],
        },
        {
          menuValue: 'Solicitudes',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'invoice',
          img: 'assets/img/icons/menu-icon-15.svg',
          subMenus: [
            {
              menuValue: 'Listado solicitudes',
              route: routes.permisosList,
              base: routes.permisosList,
              permision: 'listado_permiso',
              show_nav: true,
            },
            {
              menuValue: 'Solicitud de ausencia',
              route: routes.permisosRegister,
              base: routes.permisosRegister,
              permision: 'registrar_permiso',
              show_nav: true,
            },
            {
              menuValue: 'Editar permiso',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_permiso',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar permiso',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eleminar_permiso',
              show_nav: false,
            },
            {
              menuValue: 'Directivo permiso',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'directivo_permiso',
              show_nav: false,
            },
            {
              menuValue: 'Contralor permiso',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'contralor_permiso',
              show_nav: false,
            },
          ],
        },
        // {
        //   menuValue: 'Recibos nomina',
        //   hasSubRoute: true,
        //   showSubRoute: false,
        //   base: 'nominas',
        //   img: 'assets/img/icons/menu-icon-07.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Listado nomina',
        //       route: routes.nominaList,
        //       base: routes.nominaList,
        //       permision: 'listado_nomina',
        //       show_nav: true,
        //     },
        //     {
        //       menuValue: 'Subir recibo',
        //       route: routes.nominaRegister,
        //       base: routes.nominaRegister,
        //       permision: 'registrar_nomina',
        //       show_nav: true,
        //     },
        //     {
        //       menuValue: 'Editar recibo',
        //       route: '',
        //       base: '',
        //       permision: 'editar_nomina',
        //       show_nav: false,
        //     },
        //     {
        //       menuValue: 'Eliminar recibo',
        //       route: '',
        //       base: '',
        //       permision: 'eliminar_nomina',
        //       show_nav: false,
        //     },
        //   ],
        // },
        {
          menuValue: 'Incidencias',
          route: routes.incidenciasList,
          hasSubRoute: false,
          showSubRoute: false,
          img: 'assets/img/icons/menu-icon-14.svg',
          base: 'activities',
          permision: 'incidencias',
          show_nav: true,
          subMenus: [
            {
              menuValue: 'Consultar incidencias',
              route: routes.incidenciasList,
              base: routes.incidenciasList,
              permision: 'incidencias',
              show_nav: true,
            },
            {
              menuValue: 'Solicitar incidencias',
              route: '',
              base: '',
              permision: 'solicitar_incidencias',
              show_nav: false,
            },
            {
              menuValue: 'Procesar incidencias',
              route: '',
              base: '',
              permision: 'procesar_incidencias',
              show_nav: false,
            },
            {
              menuValue: 'Vincular móvil / QR checador',
              route: '',
              base: '',
              permision: 'vincular_movil',
              show_nav: false,
            },
          ],
        },


        // {
        //   menuValue: 'Atención Medica',
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   base: 'doctor-schedule',
        //   img: 'assets/img/icons/menu-icon-05.svg',
        //   subMenus: [
        //     {
        //       menuValue: 'Listado citas',
        //       route: routes.saludList,
        //       base: routes.saludList,
        //       permision: 'listado_medico',
        //       show_nav: true,
        //     },
        //     {
        //       menuValue: 'Solicitar cita',
        //       route: routes.saludRegister,
        //       base: routes.saludRegister,
        //       permision: 'registrar_cita',
        //       show_nav: true,
        //     },
        //     {
        //       menuValue: 'Editar cita',
        //       route: routes.registerRole,
        //       base: routes.registerRole,
        //       permision: 'editar_cita',
        //       show_nav: false,
        //     },
        //     {
        //       menuValue: 'Eliminar cita',
        //       route: routes.registerRole,
        //       base: routes.registerRole,
        //       permision: 'eliminar_cita',
        //       show_nav: false,
        //     },
        //     {
        //       menuValue: 'Procesar citas',
        //       route: routes.registerRole,
        //       base: routes.registerRole,
        //       permision: 'procesar_medico',
        //       show_nav: false,
        //     },
        //   ],
        // },


      ],
    },
    // Recursos materiales y tecnologicos
    {
      tittle: 'Recursos materiales y tecnológicos',
      showAsTab: false,
      separateRoute: false,
      menu: [
        {
          menuValue: 'Soporte técnico',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'departments',
          img: 'assets/img/icons/menu-icon-06.svg',
          subMenus: [
            {
              menuValue: 'Listado tickets',
              route: routes.mantenimientoList,
              base: routes.mantenimientoList,
              permision: 'listado_mantenimiento',
              show_nav: true,
            },
            {
              menuValue: 'Abrir ticket',
              route: routes.mantenimientoRegister,
              base: routes.mantenimientoRegister,
              permision: 'registrar_tiket',
              show_nav: true,
            },
            {
              menuValue: 'Editar ticket',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_tiket',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar ticket',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_tiket',
              show_nav: false,
            },
            {
              menuValue: 'Procesar ticket',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'procesar_tiket',
              show_nav: false,
            },
          ],
        },
        {
          menuValue: 'Papeleria/Insumos',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'forms',
          icon: 'fa-edit',
          faIcon: true,
          subMenus: [
            {
              menuValue: 'Listado',
              route: routes.insumosList,
              base: routes.insumosList,
              permision: 'listado_insumos',
              show_nav: true,
            },
            {
              menuValue: 'Solicitar insumos',
              route: routes.insumosSolicitar,
              base: routes.insumosSolicitar,
              permision: 'solicitar_insumos',
              show_nav: true,
            },
            {
              menuValue: 'Limpieza',
              route: routes.insumosLimpieza,
              base: routes.insumosLimpieza,
              permision: 'solicitar_insumos',
              show_nav: true,
            },
            {
              menuValue: 'Procesar insumos',
              route: routes.insumosSolicitar,
              base: routes.insumosSolicitar,
              permision: 'procesar_insumos',
              show_nav: false,
            },
            // {
            //   menuValue: 'Solicitar papeleria',
            //   route: routes.papeleriaSolicitar,
            //   base: routes.papeleriaSolicitar,
            //   permision: 'solicitar_papeleria',
            //   show_nav: true,
            // },
            // {
            //   menuValue: 'Solicitar insumos',
            //   route: routes.insumosSolicitar,
            //   base: routes.insumosSolicitar,
            //   permision: 'solicitar_insumos',
            //   show_nav: true,
            // },
          ],
        },
        {
          menuValue: 'Inventario/resguardo',
          hasSubRoute: true,
          showSubRoute: false,
          icon: 'fa-cube',
          faIcon: true,
          base: 'assets',
          subMenus: [
            {
              menuValue: 'Bodegas',
              route: routes.bodegas,
              base: routes.bodegas,
              permision: 'listado_bodegas',
              show_nav: false,
            },
            {
              menuValue: 'Inventario General',
              route: routes.todosInventario,
              base: routes.todosInventario,
              permision: 'listado_inventario',
              show_nav: true,
            },
            {
              menuValue: 'Archivo',
              route: routes.archivo,
              base: routes.archivo,
              permision: 'listado_archivo',
              show_nav: true,
            },
            {
              menuValue: 'Registrar Inventario',
              route: routes.inventarioRegister,
              base: routes.inventarioRegister,
              permision: 'registrar_inventario',
              show_nav: false,
            },
            {
              menuValue: 'Solicitar resguardo',
              route: routes.resguardoList,
              base: routes.resguardoList,
              permision: 'solicitar_resguardo',
              show_nav: false,
            },
            {
              menuValue: 'Editar Inventario',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_inventario',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar Inventario',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_inventario',
              show_nav: false,
            },
            {
              menuValue: 'Procesar resguardo',
              route: routes.resguardoList,
              base: routes.resguardoList,
              permision: 'procesar_resguardo',
              show_nav: false,
            },
            {
              menuValue: 'Contralor inventario',
              route: '',
              base: '',
              permision: 'contralor_inventario',
              show_nav: false,
            },
            {
              menuValue: 'Procesar inventario',
              route: '',
              base: '',
              permision: 'procesar_inventario',
              show_nav: false,
            },
            // {
            //   menuValue: 'Directivo inventario',
            //   route: '',
            //   base: '',
            //   permision: 'directivo_inventario',
            //   show_nav: false,
            // },
          ],
        },
      ],
    },
    // finanzas
    {
      tittle: 'Finanzas',
      showAsTab: false,
      separateRoute: false,
      menu: [
        {
          menuValue: 'Gastos',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'payroll',
          img: 'assets/img/icons/menu-icon-09.svg',
          subMenus: [
            {
              menuValue: 'Listado',
              route: routes.viaticosList,
              base: routes.viaticosList,
              permision: 'listado_gastos',
              show_nav: true,
            },
            {
              menuValue: 'Solicitar Gastos',
              route: routes.viaticosRegister,
              base: routes.viaticosRegister,
              permision: 'registrar_gastos',
              show_nav: true,
            },
            {
              menuValue: 'Editar Gastos',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_gastos',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar Gastos',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_gastos',
              show_nav: false,
            },
            {
              menuValue: 'Directivo Gastos',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'directivo_gastos',
              show_nav: false,
            },
            {
              menuValue: 'Procesar Gastos',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'procesar_gastos',
              show_nav: false,
            },
            {
              menuValue: 'Contralor Gastos',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'contralor_gastos',
              show_nav: false,
            },
          ],
        },
        {
          menuValue: 'Paqueteria',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'blogs',
          img: 'assets/img/icons/menu-icon-13.svg',
          subMenus: [
            {
              menuValue: 'Listado Paqueteria',
              route: routes.paqueteriaList,
              base: routes.paqueteriaList,
              permision: 'listado_paqueteria',
              show_nav: true,
            },
            {
              menuValue: 'Solicitar Paqueteria',
              route: routes.paqueteriaRegister,
              base: routes.paqueteriaRegister,
              permision: 'registrar_paqueteria',
              show_nav: true,
            },
            {
              menuValue: 'Editar Paqueteria',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_paqueteria',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar Paqueteria',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_paqueteria',
              show_nav: false,
            },
            {
              menuValue: 'Procesar Paqueteria',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'encargado_paqueteria',
              show_nav: false,
            },
          ],
        },
        {
          menuValue: 'Servicio Vehicular',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'gallery',
          base2: 'profile',
          icon: 'fa-columns',
          faIcon: true,
          subMenus: [
            {
              menuValue: 'Listado Vehiculos',
              route: routes.servehicularList,
              base: routes.servehicularList,
              permision: 'listado_vehicular',
              show_nav: true,
            },
            {
              menuValue: 'Registrar Vehiculo',
              route: routes.servehicularRegister,
              base: routes.servehicularRegister,
              permision: 'registrar_vehicular',
              show_nav: true,
            },
            {
              menuValue: 'Listado Servicio',
              route: routes.listadoServicio,
              base: routes.listadoServicio,
              permision: 'listado_servicio',
              show_nav: true,
            },
            {
              menuValue: 'Editar Vehiculo',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_vehicular',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar vehiculo',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_vehicular',
              show_nav: false,
            },
            {
              menuValue: 'Directivo vehicular',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'directivos_vehicular',
              show_nav: false,
            },
            {
              menuValue: 'Contralor vehicular',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'contralor_vehicular',
              show_nav: false,
            },

          ],
        },
      ],
    },
    // servicios
    {
      tittle: 'Visitas y Servicios',
      showAsTab: false,
      separateRoute: false,
      menu: [
        {
          menuValue: 'Visitas externas',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'patient',
          img: 'assets/img/icons/menu-icon-03.svg',
          subMenus: [
            {
              menuValue: 'Listado visitas',
              route: routes.visitasList,
              base: routes.visitasList,
              permision: 'listado_visita',
              show_nav: true,
            },
            {
              menuValue: 'Registrar visita',
              route: routes.visitasRegister,
              base: routes.visitasRegister,
              permision: 'registrar_visita',
              show_nav: true,
            },
            {
              menuValue: 'Proveedores',
              route: routes.proovedoresList,
              base: routes.proovedoresList,
              permision: 'listado_proovedor',
              show_nav: true,
            },
            {
              menuValue: 'Editar visita',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_visita',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar visita',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_visita',
              show_nav: false,
            },
          ],
        },
        {
          menuValue: 'Sala de juntas',
          hasSubRoute: true,
          showSubRoute: false,
          icon: 'fa-calendar',
          faIcon: true,
          base: 'calendar',
          subMenus: [
            {
              menuValue: 'Listado sala',
              route: routes.salaList,
              base: routes.salaList,
              permision: 'listado_sala',
              show_nav: true,
            },
            {
              menuValue: 'Solicitar Sala',
              route: routes.salaRegister,
              base: routes.salaRegister,
              permision: 'registrar_sala',
              show_nav: true,
            },
            {
              menuValue: 'Gestión de Reuniones',
              route: routes.salaGestion,
              base: routes.salaGestion,
              permision: 'editar_sala',
              show_nav: true,
            },
            {
              menuValue: 'Editar Sala',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_sala',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar Sala',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_sala',
              show_nav: false,
            },
            {
              menuValue: 'Perfil Sala',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'perfil_sala',
              show_nav: false,
            },
            {
              menuValue: 'Privilegio Sala',
              route: routes.salaRegister,
              base: routes.salaRegister,
              permision: 'privilegio_sala',
              show_nav: false,
            },
          ],
        },
        {
          menuValue: 'Diligencia',
          hasSubRoute: true,
          showSubRoute: false,
          img: 'assets/img/icons/menu-icon-14.svg',
          base: 'activities',
          subMenus: [
            {
              menuValue: 'Listado diligencia',
              route: routes.diligenciaList,
              base: routes.diligenciaList,
              permision: 'listado_diligencia',
              show_nav: true,
            },
            {
              menuValue: 'Solicitar diligencia',
              route: routes.diligenciaRegister,
              base: routes.diligenciaRegister,
              permision: 'registrar_diligencia',
              show_nav: true,
            },
            {
              menuValue: 'Crear gastos',
              route: routes.diligenciaCrearGastos,
              base: routes.diligenciaCrearGastos,
              permision: 'registrar_diligencia',
              show_nav: true,
            },
            {
              menuValue: 'Aprobar diligencias',
              route: routes.diligenciaAprobacionArea,
              base: routes.diligenciaAprobacionArea,
              permision: 'aprobar_diligencia_area',
              show_nav: true,
            },
            {
              menuValue: 'Editar diligencia',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_diligencia',
              show_nav: false,
            },
            {
              menuValue: 'Eliminar diligencia',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_diligencia',
              show_nav: false,
            },
            {
              menuValue: 'Directivo diligencia',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'directivo_diligencia',
              show_nav: false,
            },
            {
              menuValue: 'Contralor diligencia',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'contralor_diligencia',
              show_nav: false,
            },
            {
              menuValue: 'Procesar diligencia',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'procesar_diligencia',
              show_nav: false,
            },
          ],
        },
        {
          menuValue: 'Mensajeria',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'email',
          img: 'assets/img/icons/menu-icon-12.svg',
          subMenus: [
            {
              menuValue: 'Listado mensajeria',
              route: routes.mensajeriaList,
              base: routes.mensajeriaList,
              permision: 'listado_mensajeria',
              show_nav: true,
            },
            {
              menuValue: 'editar mensajeria',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_mensajeria',
              show_nav: false,
            },
            {
              menuValue: 'procesar mensajeria',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'procesar_mensajeria',
              show_nav: false,
            },
          ],
        },
        {
          menuValue: 'Diseño grafico',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'gallery',
          base2: 'profile',
          icon: 'fa-columns',
          faIcon: true,
          subMenus: [
            {
              menuValue: 'Listado diseño',
              route: routes.ilustracionesList,
              base: routes.ilustracionesList,
              permision: 'listado_diseño',
              show_nav: true,
            },
            {
              menuValue: 'solicitar diseño',
              route: routes.ilustracionesRegister,
              base: routes.ilustracionesRegister,
              permision: 'registrar_diseño',
              show_nav: true,
            },
            {
              menuValue: 'editar diseño',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_diseño',
              show_nav: false,
            },
            {
              menuValue: 'eliminar diseño',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_diseño',
              show_nav: false,
            },
            {
              menuValue: 'procesar diseño',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'procesar_diseño',
              show_nav: false,
            },
          ],
        },
      ],
    },
    // comunidad carma
    {
      tittle: 'Comunidad Carma/HW',
      showAsTab: false,
      separateRoute: false,
      menu: [
        {
          menuValue: 'comunicados',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'chat',
          img: 'assets/img/icons/menu-icon-10.svg',
          subMenus: [
            {
              menuValue: 'Listado comunicados',
              route: routes.comunicadoList,
              base: routes.comunicadoList,
              permision: 'listado_comunicado',
              show_nav: true,
            },
            {
              menuValue: 'Registrar comunicado',
              route: routes.comunicadoRegister,
              base: routes.comunicadoRegister,
              permision: 'registrar_comunicado',
              show_nav: true,
            },
            {
              menuValue: 'Eliminar comunicado',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_comunicado',
              show_nav: false,
            },
            {
              menuValue: 'Editar comunicado',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_comunicado',
              show_nav: false,
            },
          ],
        },

        {
          menuValue: 'Quejas/Sugerencias',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'chat',
          img: 'assets/img/icons/menu-icon-10.svg',
          subMenus: [
            {

              menuValue: 'Listado quejas',
              route: routes.quejasList,
              base: routes.quejasList,
              permision: 'listado_quejas',
              show_nav: true,
            },
            {
              menuValue: 'Registrar queja',
              route: routes.quejasRegister,
              base: routes.quejasRegister,
              permision: 'registrar_quejas',
              show_nav: true,
            },
            {
              menuValue: 'Eliminar queja',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_quejas',
              show_nav: false,
            },
            {
              menuValue: 'Editar queja',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_quejas',

            },
          ],
        },
        {
          menuValue: 'Políticas',
          hasSubRoute: true,
          showSubRoute: false,
          base: 'chat',
          img: 'assets/img/icons/menu-icon-10.svg',
          subMenus: [
            {


              menuValue: 'Listado políticas',
              route: routes.politicasList,
              base: routes.politicasList,
              permision: 'listado_politicas',
              show_nav: true,
            },
            {
              menuValue: 'Registrar políticas',
              route: routes.politicasRegister,
              base: routes.politicasRegister,
              permision: 'registrar_politicas',
              show_nav: true,
            },
            {
              menuValue: 'Eliminar política',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'eliminar_politicas',
              show_nav: false,
            },
            {
              menuValue: 'Editar política',
              route: routes.registerRole,
              base: routes.registerRole,
              permision: 'editar_politicas',
              show_nav: false,
            },
          ],
        },

      ],
    },
    //iu elements
    // {
    //   tittle: 'UI Elements',
    //   showAsTab: false,
    //   separateRoute: false,
    //   menu: [
    //     {
    //       menuValue: 'Components',
    //       hasSubRoute: true,
    //       showSubRoute: false,
    //       base: 'components',
    //       img: 'assets/img/icons/menu-icon-02.svg',
    //       subMenus: [
    //         {
    //           menuValue: 'UI Kit',
    //           route: routes.uikit,
    //           base: routes.uikit,
    //         },
    //         {
    //           menuValue: 'Typography',
    //           route: routes.typography,
    //           base: routes.typography,
    //         },
    //         {
    //           menuValue: 'Tabs',
    //           route: routes.tabs,
    //           base: routes.tabs,
    //         },
    //       ],
    //     },
    //     {
    //       menuValue: 'Forms',
    //       hasSubRoute: true,
    //       showSubRoute: false,
    //       base: 'forms',
    //       icon: 'fa-edit',
    //       faIcon: true,
    //       subMenus: [
    //         {
    //           menuValue: 'Basic Inputs',
    //           route: routes.formBasicInputs,
    //           base: routes.formBasicInputs,
    //         },
    //         {
    //           menuValue: 'Input Groups',
    //           route: routes.formInputGroups,
    //           base: routes.formInputGroups,
    //         },
    //         {
    //           menuValue: 'Horizontal Form',
    //           route: routes.formHorizontal,
    //           base: routes.formHorizontal,
    //         },
    //         {
    //           menuValue: 'Vertical Form',
    //           route: routes.formVertical,
    //           base: routes.formVertical,
    //         },
    //       ],
    //     },
    //     {
    //       menuValue: 'Tables',
    //       hasSubRoute: true,
    //       showSubRoute: false,
    //       base: 'tables',
    //       icon: 'fa-table',
    //       faIcon: true,
    //       subMenus: [
    //         {
    //           menuValue: 'Basic Tables',
    //           route: routes.tablesBasic,
    //           base: routes.tablesBasic,
    //         },
    //         {
    //           menuValue: 'Data Table',
    //           route: routes.tablesDataTables,
    //           base: routes.tablesDataTables,
    //         },
    //       ],
    //     },
    //     {
    //       menuValue: 'Calendar',
    //       route: routes.calendar,
    //       hasSubRoute: false,
    //       showSubRoute: false,
    //       icon: 'fa-calendar',
    //       faIcon: true,
    //       base: 'calendar',
    //       subMenus: [],
    //     },
    //   ],
    // },
    //extras
    // {
    //   tittle: 'Extras',
    //   showAsTab: false,
    //   separateRoute: false,
    //   menu: [
    //     {
    //       menuValue: 'Pages',
    //       hasSubRoute: true,
    //       showSubRoute: false,
    //       base: 'gallery',
    //       base2: 'profile',
    //       icon: 'fa-columns',
    //       faIcon: true,
    //       subMenus: [
    //         {
    //           menuValue: 'Login',
    //           route: routes.login,
    //           base: routes.login,
    //         },
    //         {
    //           menuValue: 'Register',
    //           route: routes.register,
    //           base: routes.register,
    //         },
    //         {
    //           menuValue: 'Forgot Password',
    //           route: routes.forgotPassword,
    //           base: routes.forgotPassword,
    //         },
    //         {
    //           menuValue: 'Change Password',
    //           route: routes.changePassword,
    //           base: routes.changePassword,
    //         },
    //         {
    //           menuValue: 'Lock Screen',
    //           route: routes.lockScreen,
    //           base: routes.lockScreen,
    //         },
    //         {
    //           menuValue: 'Profile',   //****************** */
    //           route: routes.profile,
    //           base: routes.profile,
    //         },
    //         {
    //           menuValue: 'Gallery',
    //           route: routes.gallery,
    //           base: routes.gallery,
    //         },
    //         {
    //           menuValue: '404 Error',
    //           route: routes.error404,
    //           base: routes.error404,
    //         },
    //         {
    //           menuValue: '500 Error',
    //           route: routes.error500,
    //           base: routes.error500,
    //         },
    //       ],
    //     },

    //   ],
    // },
  ];

  public sideBarSinPermisosRepetidos(): SeccionSideBar[] {
    const secciones = this.sideBar as unknown as SeccionSideBar[];

    return (secciones || []).map((side) => ({
      ...side,
      menu: (side.menu || []).map((menu) => {
        if (!menu.subMenus || menu.subMenus.length === 0) {
          return { ...menu };
        }
        const permisosVistos = new Set<string>();

        return {
          ...menu,
          subMenus: menu.subMenus.filter((sub) => {
            if (!sub.permision) {
              return true; // sin permiso no hay nada que deduplicar
            }
            if (permisosVistos.has(sub.permision)) {
              return false;
            }
            permisosVistos.add(sub.permision);
            return true;
          }),
        };
      }),
    }));
  }

  public carousel1 = [
    {
      quantity: '68',
      units: 'kg',
    },
    {
      quantity: '70',
      units: 'kg',
    },
    {
      quantity: '72',
      units: 'kg',
    },
    {
      quantity: '74',
      units: 'kg',
    },
    {
      quantity: '76',
      units: 'kg',
    },
  ];
  public carousel2 = [
    {
      quantity: '160',
      units: 'cm',
    },
    {
      quantity: '162',
      units: 'cm',
    },
    {
      quantity: '164',
      units: 'cm',
    },
    {
      quantity: '166',
      units: 'cm',
    },
    {
      quantity: '168',
      units: 'cm',
    },
  ];
  public socialLinks = [
    {
      icon: 'facebook',
      placeholder: 'https://www.facebook.com'
    },
    {
      icon: 'twitter',
      placeholder: 'https://www.twitter.com'
    },
    {
      icon: 'youtube',
      placeholder: 'https://www.youtube.com'
    },
    {
      icon: 'linkedin',
      placeholder: 'https://www.linkedin.com'
    }
  ];
  public upcomingAppointments = [
    {
      "no": "R00001",
      "patientName": "Andrea Lalema",
      "doctor": "Dr.Jenny Smith",
      "date": "12.05.2022 at",
      "time": "7.00 PM",
      "disease": "Fracture",
      "img": "assets/img/profiles/avatar-03.jpg"
    },
    {
      "no": "R00002",
      "patientName": "Cristina Groves",
      "doctor": "Dr.Angelica Ramos",
      "date": "13.05.2022 at",
      "time": "7.00 PM",
      "disease": "Fever",
      "img": "assets/img/profiles/avatar-05.jpg"
    },
    {
      "no": "R00003",
      "patientName": "Bernardo",
      "doctor": "Dr.Martin Doe",
      "date": "14.05.2022 at",
      "time": "7.00 PM",
      "disease": "Fracture",
      "img": "assets/img/profiles/avatar-04.jpg"
    },
    {
      "no": "R00004",
      "patientName": "Galaviz Lalema",
      "doctor": "Dr.Martin Doe",
      "date": "15.05.2022 at",
      "time": "7.00 PM",
      "disease": "Fracture",
      "img": "assets/img/profiles/avatar-03.jpg"
    },
    {
      "no": "R00005",
      "patientName": "Dr.William Jerk",
      "doctor": "Dr.Angelica Ramos",
      "date": "16.05.2022 at",
      "time": "7.00 PM",
      "disease": "Fever",
      "img": "assets/img/profiles/avatar-02.jpg"
    }
  ];
  public recentPatients = [
    {
      "no": "R00001",
      "patientName": "Andrea Lalema",
      "age": "21",
      "date": "12.05.2022 at",
      "dateOfBirth": "07 January 2002",
      "diagnosis": "Heart attack",
      "img": "assets/img/profiles/avatar-02.jpg",
      "triage": "Non Urgent"
    },
    {
      "no": "R00002",
      "patientName": "Mark Hay Smith",
      "age": "23",
      "date": "13.05.2022 at",
      "dateOfBirth": "06 January 2002",
      "diagnosis": "Jaundice",
      "img": "assets/img/profiles/avatar-03.jpg",
      "triage": "Emergency"
    },
    {
      "no": "R00003",
      "patientName": "Cristina Groves",
      "age": "25",
      "date": "14.05.2022 at",
      "dateOfBirth": "10 January 2002",
      "diagnosis": "Malaria",
      "img": "assets/img/profiles/avatar-04.jpg",
      "triage": "Out Patient"
    },
    {
      "no": "R00004",
      "patientName": "Galaviz Lalema",
      "age": "21",
      "date": "15.05.2022 at",
      "dateOfBirth": "09 January 2002",
      "diagnosis": "Typhoid",
      "img": "assets/img/profiles/avatar-05.jpg",
      "triage": "Urgent"
    }
  ];
  public patientProfile = [
    {
      date: "29/09/2022",
      doctor: "Dr.Jenny Smith",
      treatment: "Check up",
      charges: "$ 60"
    },
    {
      date: "19/09/2022",
      doctor: "Andrea Lalema",
      treatment: "	Blood Test",
      charges: "$ 50"
    },
    {
      date: "20/09/2022",
      doctor: "Dr.William Stephin",
      treatment: "Blood Pressure",
      charges: "$ 30"
    }
  ];
  public blogs = [
    {
      img1: "assets/img/blog/blog-1.jpg",
      img2: "assets/img/profiles/avatar-01.jpg",
      heading5: "Diabetes",
      count1: "58",
      count2: "500",
      date: "05 Sep 2022",
      heading4: "Jenifer Robinson",
      name: "M.B.B.S, Diabetologist",
      heading3: "Simple Changes That Lowered My Mom's Blood Pressure",
      paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...",
      msg: "Read more in 8 Minutes"
    },
    {
      img1: "assets/img/blog/blog-2.jpg",
      img2: "assets/img/profiles/avatar-02.jpg",
      heading5: "Safety",
      count1: "18",
      count2: "5k",
      date: "05 Sep 2022",
      heading4: "Mark hay smith",
      name: "M.B.B.S, Neurologist",
      heading3: "Vaccines Are Close - But Right Now We Need to Hunker Down",
      paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...",
      msg: "Read more in 2 Minutes"
    },
    {
      img1: "assets/img/blog/blog-3.jpg",
      img2: "assets/img/profiles/avatar-03.jpg",
      heading5: "Dermotology",
      count1: "28",
      count2: "2.5k",
      date: "05 Sep 2022",
      heading4: "Denise Stevens",
      name: "M.B.B.S, Dermotologist",
      heading3: "Hair Loss On One Side of Head – Causes & Treatments",
      paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...",
      msg: "Read more in 3 Minutes"
    },
    {
      img1: "assets/img/blog/blog-4.jpg",
      img2: "assets/img/profiles/avatar-05.jpg",
      heading5: "Ophthalmology",
      count1: "48",
      count2: "600",
      date: "05 Sep 2022",
      heading4: "Laura Williams",
      name: "M.B.B.S, Ophthalmologist",
      heading3: "Eye Care Routine To Get Rid Of Under Eye Circles And Puffiness",
      paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...",
      msg: "Read more in 5 Minutes"
    },
    {
      img1: "assets/img/blog/blog-5.jpg",
      img2: "assets/img/profiles/avatar-06.jpg",
      heading5: "Dentist",
      count1: "48",
      count2: "600",
      date: "05 Sep 2022",
      heading4: "Linda Carpenter",
      name: "M.B.B.S, Dentist",
      heading3: "5 Facts About Teeth Whitening You Should Know",
      paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...",
      msg: "Read more in 3 Minutes"
    },
    {
      img1: "assets/img/blog/blog-6.jpg",
      img2: "assets/img/profiles/avatar-04.jpg",
      heading5: "Gynecologist",
      count1: "18",
      count2: "300",
      date: "05 Sep 2022",
      heading4: "Mark hay smith",
      name: "M.B.B.S, Gynecologist",
      heading3: "Sciatica: Symptoms, Causes & Treatments",
      paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...",
      msg: "Read more in 10 Minutes"
    }
  ];
  public invoicesGrid = [
    {
      invoiceNumber: "IN093439#@09",
      name: "Barbara Moore",
      img: "assets/img/profiles/avatar-04.jpg",
      amount: "Amount",
      amounts: "$1,54,220",
      text: "Due Date",
      dueDate: "23 Mar 2022",
      status: "Paid",
    },
    {
      invoiceNumber: "IN093439#@10",
      name: "Karlene Chaidez",
      img: "assets/img/profiles/avatar-06.jpg",
      amount: "Amount",
      amounts: "$1,222",
      text: "Due Date",
      dueDate: "18 Mar 2022",
      status: "Overdue",
      overDue: "Overdue 14 days"
    },
    {
      invoiceNumber: "IN093439#@11",
      name: "Russell Copeland",
      img: "assets/img/profiles/avatar-08.jpg",
      amount: "Amount",
      amounts: "$3,470",
      text: "Due Date",
      dueDate: "10 Mar 2022",
      status: "Cancelled",
    },
    {
      invoiceNumber: "IN093439#@12",
      name: "Joseph Collins",
      img: "assets/img/profiles/avatar-10.jpg",
      amount: "Amount",
      amounts: "$8,265",
      text: "Due Date",
      dueDate: "30 Mar 2022",
      status: "Sent",
    },
    {
      invoiceNumber: "IN093439#@13",
      name: "Jennifer Floyd",
      img: "assets/img/profiles/avatar-11.jpg",
      amount: "Amount",
      amounts: "$5,200",
      text: "Due Date",
      dueDate: "20 Mar 2022",
      status: "Cancelled",
    },
    {
      invoiceNumber: "IN093439#@14",
      name: "Leatha Bailey",
      img: "assets/img/profiles/avatar-09.jpg",
      amount: "Amount",
      amounts: "$480",
      text: "Due Date",
      dueDate: "15 Mar 2022",
      status: "Sent",
    },
    {
      invoiceNumber: "IN093439#@15",
      name: "Alex Campbell",
      img: "assets/img/profiles/avatar-12.jpg",
      amount: "Amount",
      amounts: "$1,999",
      text: "Due Date",
      dueDate: "08 Mar 2022",
      status: "Overdue",
      overDue: "Overdue 10 days"
    },
    {
      invoiceNumber: "IN093439#@16",
      name: "Marie Canales",
      img: "assets/img/profiles/avatar-03.jpg",
      amount: "Amount",
      amounts: "$2,700",
      text: "Due Date",
      dueDate: "18 Mar 2022",
      status: "Paid",
    },
  ]
}
